import API from 'services/API';

export const getSecteurInformations = (id) => API.get(`/sectors/${id}`);

// CULTURES

export const getCultures = (organic, id) =>
  API.get(`/sectors/${id}/cultures`, {
    params: {
      organic,
    },
  });

export const updateCulture = (id, data, idCulture) =>
  API.patch(`/sectors/${id}/cultures/edit/${idCulture}`, data);

export const resetSectorCultures = (sector) => API.patch(`/sectors/${sector.id}/cultures/reset`);

// ROTATE EFFECTS

export const getSecteurCultures = (organic, id, sort = 'name') =>
  API.get(`/sectors/${id}/cultures`, {
    params: {
      organic,
      sort,
    },
  });

// EXPLOITATIONS

export const addExploitation = (data) => API.post('/exploitations/add', data);

export const updateExploitation = (data, id) => API.patch(`/exploitations/edit/${id}`, data);

export const removeExploitation = (id) => API.delete(`/exploitations/remove/${id}`);

export const addFarmer = (farmer) => API.post('/users/add', farmer);

export const removeFarmer = (id) => API.delete(`/users/remove/${id}`);

export default {
  getSecteurInformations,
};

// NON RETURNCULTURE GROUP
export const getSectorNonReturnCultureGroupList = (sectorId) =>
  API.get(`/sector/${sectorId}/non-return-culture-group`);

export const addSectorNonReturnCultureGroup = (sectorId, culture) =>
  API.post(`/sector/${sectorId}/non-return-culture-group`, culture);

export const updateSectorNonReturnCultureGroup = (sectorId, cultureGroupId, culture) =>
  API.patch(`/sector/${sectorId}/non-return-culture-group/${cultureGroupId}`, culture);

export const deleteSectorNonReturnCultureGroup = (sectorId, cultureGroup) =>
  API.delete(`/sector/${sectorId}/non-return-culture-group`, {
    data: cultureGroup,
  });
